import { useEffect, useMemo, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import ADDRESSES_QUERY from '../queries/ADDRESSES_QUERY';
 
const useILTAddresses = () => {
    const [ addresses, setAddresses ] = useState( [] );
    const [ fetchAddresses, { data, loading, error } ] = useLazyQuery( ADDRESSES_QUERY, {
        variables: {
            page: 1,
            limit: 10000,
            orderBy: 'createdAt',
            orderDir: 'desc',
        },
        fetchPolicy: 'network-only'
    } );

    useEffect( () => {
        fetchAddresses();
    }, [] );

    useEffect( () => {
        if ( loading || error || !data || !data.addresses?.edges ) { return; }
        
        try {
            const result = data.addresses.edges.map( i => { 
                return {
                    key: i.node?.id || '',
                    ...i.node, 
                }; 
            } );

            setAddresses( result );
        } catch ( error ) {
            console.error( 'Error parsing addresses', error ); 
            setAddresses( [] );
        }
    }, [ loading, error ] );
   
    return useMemo( () => {
        return {
            addresses,
            addressesError: error,
            addressesLoading: loading, 
        };
    }, [ addresses, error, loading ] );
};

export default useILTAddresses;
